const routes = {
  en: {
    translation: {
      menu: "Menu",
      list: "List",
      cart: "Cart",
      delivery_info: "Delivery info",
      contacts: "Contacts",
      information: "Information"
    }
  },
  it: {
    translation: {
      menu: "Menu",
      list: "Lista",
      cart: "Carrello",
      delivery_info: "Delivery info",
      contacts: "Contatti",
      information: "Informazioni"
    }
  }
};

export default routes;
